<div [ngBusy]="{busy: locationLoading, message: ('common.pleaseWait' | translate)}">
  <i class="icon-close cursor-pointer outer-modal-close" (click)="modal.dismiss()"></i>

  <faq-form *ngIf="showedForm===FORM.FAQ"
            (onLocationFound)="onLocationFound($event)"
            (onFormChange)="showedForm=FORM.CONTACT_US"></faq-form>

  <contact-us-form *ngIf="showedForm===FORM.CONTACT_US"
                   [isSuccess]="isSuccess"
                   [showBack]="showBack"
                   (onSend)="send($event)"
                   (onFormChange)="showedForm=FORM.FAQ"></contact-us-form>
  <report-missing-bakery-form *ngIf="showedForm===FORM.MISSING_BAKERY_REPORT"
                              [isSuccess]="isSuccess"
                              (onSend)="send($event)"
                              (onFormChange)="showedForm=FORM.FAQ"></report-missing-bakery-form>
</div>
